import { Logger } from './logger'

export { check, LEVELS } from './level'
export { Logger, logger } from './logger'

// mock console with our logger
globalThis.console = new Logger('console') as unknown as Console
